<template>
  <ol class="breadcrumb-group">
    <li
      v-for="(item, index) in items"
      :key="'breadcrumb' + index"
      role="presentation"
      class="item"
      :class="{ active: item.active }"
    >
      <router-link v-if="item.routerName" :to="{ name: item.routerName }">{{
        item.text
      }}</router-link>
      <a v-else-if="item.href" href="#" target="_self" class="">{{
        item.text
      }}</a>
      <span v-else>{{ item.text }}</span>
      <span class="icon">></span>
    </li>
  </ol>
</template>

<script>
export default {
  name: "BreadcrumbGroup",
  props: {
    items: { type: Object, default: () => {} },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.breadcrumb-group {
  margin-bottom: 15px;
  @include mq-up(md) {
    margin-bottom: 20px;
  }
  > .item {
    font-size: 10px;
    line-height: 14px;
    display: inline-block;
    @include mq-up(md) {
      line-height: 20px;
      font-size: 14px;
    }
    a {
      text-decoration: underline;
      &:hover {
        color: $orange;
      }
    }
    > .icon {
      margin-left: 5px;
      margin-right: 5px;
      &:before {
        // vue2環境の余白に寄せるためスペースを挿入
        content: "\0020";
      }
    }
  }
  > li:last-child {
    > .icon {
      display: none;
    }
  }
}
</style>
